import type { MaybeComputedElementRef } from "@vueuse/core";
import type { RefOrGetter } from "ls/common/types";
import { useElementAutoFocus, useElementAutoSelect } from "ls/composables/useElementAutos";

export interface TextFieldAutosProps {
  autofocus?: boolean;
  autoselect?: boolean;
}

interface TextFieldAutosOptions {
  autofocus?: RefOrGetter<boolean>;
  autoselect?: RefOrGetter<boolean>;
}

export function useTextFieldAutos(ref: MaybeComputedElementRef<HTMLInputElement>, options: TextFieldAutosOptions = {}) {
  useElementAutoFocus(ref, { enabled: options.autofocus });
  useElementAutoSelect(ref, { enabled: options.autoselect });
}
